import { useTranslation } from "react-i18next";

/** Admin chrome is English-only regardless of the product language. */
export function useAdminT() {
  return useTranslation("admin", { lng: "en" }).t;
}
